import type * as Types from 'app/types/graphql';

export type CampaignWithVariantTemplateEdgeSelectFragment = Pick<Types.CampaignEdge, 'cursor'> & {
  node?: Types.Maybe<
    Pick<
      Types.Campaign,
      | 'id'
      | 'name'
      | 'type'
      | 'status'
      | 'priority'
      | 'storeDomain'
      | 'targetDevices'
      | 'targetChannels'
      | 'targetCountries'
      | 'targetVisitorTypes'
      | 'conditions'
      | 'createdAt'
      | 'updatedAt'
      | 'startedAt'
      | 'deletedAt'
      | 'completedAt'
    > & {
      variants?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.Variant,
              | 'id'
              | 'isOrigin'
              | 'isWinner'
              | 'trafficRate'
              | 'themePageID'
              | 'templateType'
              | 'templateSuffix'
              | 'createdAt'
              | 'deletedAt'
              | 'updatedAt'
              | 'winnerTemplateSuffix'
            > & {
              template?: Types.Maybe<
                Pick<
                  Types.VariantTemplate,
                  | 'createdAt'
                  | 'deletedAt'
                  | 'id'
                  | 'redirectURL'
                  | 'themeID'
                  | 'updatedAt'
                  | 'thumbnailURL'
                  | 'title'
                >
              >;
              price?: Types.Maybe<
                Pick<
                  Types.VariantPrice,
                  | 'id'
                  | 'baseID'
                  | 'handle'
                  | 'status'
                  | 'title'
                  | 'redirectURL'
                  | 'sourceProductBaseID'
                >
              >;
              productVariants?: Types.Maybe<
                Array<
                  Types.Maybe<
                    Pick<
                      Types.VariantProductVariant,
                      'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                    >
                  >
                >
              >;
              url?: Types.Maybe<
                Pick<
                  Types.VariantUrl,
                  'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
                >
              >;
            }
          >
        >
      >;
      group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
      versions?: Types.Maybe<
        Array<
          Types.Maybe<
            Pick<
              Types.SplitTestingCampaignVersion,
              'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
            >
          >
        >
      >;
    }
  >;
};

export type CampaignWithVariantTemplateSelectFragment = Pick<
  Types.Campaign,
  | 'id'
  | 'name'
  | 'type'
  | 'status'
  | 'priority'
  | 'storeDomain'
  | 'targetDevices'
  | 'targetChannels'
  | 'targetCountries'
  | 'targetVisitorTypes'
  | 'conditions'
  | 'createdAt'
  | 'updatedAt'
  | 'startedAt'
  | 'deletedAt'
  | 'completedAt'
> & {
  variants?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.Variant,
          | 'id'
          | 'isOrigin'
          | 'isWinner'
          | 'trafficRate'
          | 'themePageID'
          | 'templateType'
          | 'templateSuffix'
          | 'createdAt'
          | 'deletedAt'
          | 'updatedAt'
          | 'winnerTemplateSuffix'
        > & {
          template?: Types.Maybe<
            Pick<
              Types.VariantTemplate,
              | 'createdAt'
              | 'deletedAt'
              | 'id'
              | 'redirectURL'
              | 'themeID'
              | 'updatedAt'
              | 'thumbnailURL'
              | 'title'
            >
          >;
          price?: Types.Maybe<
            Pick<
              Types.VariantPrice,
              | 'id'
              | 'baseID'
              | 'handle'
              | 'status'
              | 'title'
              | 'redirectURL'
              | 'sourceProductBaseID'
            >
          >;
          productVariants?: Types.Maybe<
            Array<
              Types.Maybe<
                Pick<
                  Types.VariantProductVariant,
                  'id' | 'baseID' | 'name' | 'price' | 'compareAtPrice' | 'variantID'
                >
              >
            >
          >;
          url?: Types.Maybe<
            Pick<
              Types.VariantUrl,
              'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
            >
          >;
        }
      >
    >
  >;
  group?: Types.Maybe<Pick<Types.CampaignGroup, 'id' | 'title' | 'type'>>;
  versions?: Types.Maybe<
    Array<
      Types.Maybe<
        Pick<
          Types.SplitTestingCampaignVersion,
          'id' | 'version' | 'settings' | 'startedAt' | 'completedAt'
        >
      >
    >
  >;
};

export const CampaignWithVariantTemplateSelectFragmentDoc = `
    fragment CampaignWithVariantTemplateSelect on Campaign {
  ...CampaignSelect
  variants {
    ...VariantWithTemplateSelect
  }
}
    `;
export const CampaignWithVariantTemplateEdgeSelectFragmentDoc = `
    fragment CampaignWithVariantTemplateEdgeSelect on CampaignEdge {
  cursor
  node {
    ...CampaignWithVariantTemplateSelect
  }
}
    `;
